/**
 * Mixin to house specific functionality for our Toasts.
 */

// [ ] TODO CLEAN: Shouldn't have to do this -- needed in order to pass Designer linting rules.
/* eslint-disable */

import _ from 'lodash';

export default {
  data() {
    return {
      Toast: this.$swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      }),
    };
  },
  methods: {
    fireToast(options = {}) {
      this.Toast.fire({
        icon: _.has(options, 'icon') ? options.icon : 'success',
        iconColor: _.has(options, "iconColor") ? options.iconColor : this.$vuetify.theme.primary,
        title: _.has(options, 'title') ? options.title : 'hear hear!',
        timer: _.has(options, 'timer') ? options.timer : 5000,
        position: _.has(options, 'position') ? options.position : 'center',
        customClass: {
          title: _.get(options, 'customClass.title', ''),
          container: _.get(options, 'customClass.container', ''),
        },
        ...(_.isFunction(options.willClose) && { willClose: options.willClose.bind(this) }),
      });
    },
  },
};
